var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62.3 61",
    style: {
      enableBackground: "new 0 0 62.3 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D12443;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#557AFF;}\n\t.st3{fill:#6D98F7;}\n\t.st4{fill:#2762CC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1183_5_",
    className: "st0",
    points: "39.1,48.6 39.1,36.7 28.8,30.8 18.6,36.7 18.6,48.6 28.8,54.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,44.7c-0.6,0-1-0.4-1-1v-5.6c0-0.6,0.4-1,1-1s1,0.4,1,1v5.6C29.7,44.3,29.3,44.7,28.7,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 28.7,
    cy: 47.1,
    r: 1.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.9,13.6c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6S56.3,13.6,54.9,13.6z M54.9,9.4 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C56.5,10.1,55.8,9.4,54.9,9.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    className: "st2",
    points: "26.9,6.5 21.1,9.9 27.3,13.4 33.1,10  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "st3",
    points: "21.1,9.9 21.1,16.4 27.3,19.9 27.3,13.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    className: "st4",
    points: "27.3,19.9 33.1,16.6 33.1,10 27.3,13.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27_1_",
    className: "st2",
    points: "13.1,14.5 7.3,17.8 13.5,21.3 19.3,18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29_1_",
    className: "st3",
    points: "7.3,17.8 7.3,24.4 13.5,27.9 13.5,21.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31_1_",
    className: "st4",
    points: "13.5,27.9 19.3,24.5 19.3,18 13.5,21.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    className: "st2",
    points: "46.2,17.3 40.4,20.7 46.6,24.2 52.4,20.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    className: "st3",
    points: "40.4,20.7 40.4,27.2 46.6,30.7 46.6,24.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    className: "st4",
    points: "46.6,30.7 52.4,27.4 52.4,20.8 46.6,24.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,47.2l-0.4-0.6l1.7-1l0.4,0.6L44,47.2z M47.4,45.1l-0.4-0.6l1.7-1l0.4,0.6L47.4,45.1z M50.9,43.1l-0.4-0.6 l1.7-1l0.4,0.6L50.9,43.1z M54.3,41l-0.4-0.6l0.6-0.4v-0.8h0.8v1.3L54.3,41z M55.3,37.1h-0.8v-2h0.8V37.1z M55.3,33.1h-0.8v-2h0.8 V33.1z M55.3,29.1h-0.8v-2h0.8V29.1z M55.3,25.1h-0.8v-2h0.8V25.1z M55.3,21.1h-0.8v-2h0.8V21.1z M55.3,17.1h-0.8v-2h0.8V17.1z  M55.3,13.1h-0.8v-0.6h0.8V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.5,24.2l-0.4-0.7l1.7-1l0.4,0.7L20.5,24.2z M24,22.2l-0.4-0.7l1.7-1l0.4,0.7L24,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.8,26.2l-1.7-1l0.4-0.7l1.7,1L37.8,26.2z M34.3,24.2l-1.7-1l0.4-0.7l1.7,1L34.3,24.2z M30.9,22.2l-0.5-0.3 l0.4-0.6l0.5,0.3L30.9,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.7,16L41,15l0.4-0.7l1.7,1L42.7,16z M39.2,14l-1.7-1l0.4-0.7l1.7,1L39.2,14z M35.8,12l-0.5-0.3l0.4-0.7 l0.5,0.3L35.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,13.8l-0.4-0.7l1.7-1l0.4,0.7L15,13.8z M18.4,11.8l-0.4-0.7l1.3-0.8l0.4,0.7L18.4,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.5,38.5l-1.7-1l0.4-0.6l1.7,1L13.5,38.5z M10,36.4l-1.7-1l0.4-0.6l1.7,1L10,36.4z M6.6,34.4l-1.4-0.8 c-0.2-0.1-0.3-0.3-0.4-0.5l0.7-0.3c0,0,0.1,0.1,0.1,0.1L7,33.8L6.6,34.4z M6.6,32l-0.2-0.3l-0.2-0.3l1.7-1L8.3,31L6.6,32z M10,30 l-0.4-0.7l1.7-1l0.4,0.7L10,30z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a816d9db18f92a97b614f45ec8dada71.svg";
export { ForwardRef as ReactComponent };